// Central registry of `data-tour` anchor ids. Usage sites spread these constants
// instead of writing bare string literals, so a step definition and its anchor
// can never silently drift apart. Sidebar nav items derive their anchor from the
// route path via `navAnchor` — one rule covers every current and future item.
//
// The `nav:` prefix is load-bearing: TourProvider ensures the sidebar is expanded
// (desktop) before resolving any anchor whose value starts with it.

export const TOUR_ANCHORS = {
  sidebarNav: 'nav:sidebar',
  userMenu: 'nav:user-menu',
  dailyOverviewPage: 'daily-overview.page',
  dailyOverviewActivationLadder: 'daily-overview.activation-ladder',
  recommendationsList: 'recommendations.list',
  recommendationBudget: 'recommendations.budget',
  purchaseOrdersList: 'purchase-orders.list',
  productsList: 'products.list',
  productDetailForecast: 'product-detail.forecast',
  inventoryHealthPage: 'inventory-health.page',
  suppliersPerformance: 'suppliers.performance',
} as const;

// Adaptive detail steps (v3.4): a list page can publish the route of its first
// (most relevant) entity's detail page under this attribute, on the same
// element that carries its `data-tour` anchor. At user-navigation time the
// engine reads it to upgrade an adaptive step onto the real detail page; when
// the list is empty (fresh account) the attribute is absent and the step runs
// as its authored fallback (illustrated centered card).
export const TOUR_DETAIL_PATH_ATTR = 'data-tour-detail-path';

export function navAnchor(path: string): string {
  return `nav:${path}`;
}
